<template>
  <div id="timelayer-drawer" class="timelayer-drawer">
    <div>
      <v-navigation-drawer
        v-model="drawer"
        class="timelayer-drawer-timeline-wrapper"
        width="130px"
        height="100%"
        elevation="0"
        disable-route-watcher
        :class="{
          'timelayer-drawer-timeline-wrapper-huygens':
            getAppName() == 'huygens',
          'timelayer-drawer-timeline-wrapper-dordrecht5D':
            getAppName() == 'dordrecht5D',
          'timelayer-drawer-timeline-wrapper-canals5D':
            getAppName() == 'canals5D'
        }"
      >
        <div
          class="timelayers-wrapper"
          :style="{ height: timeLayersHeight + 'px' }"
          @mouseover="cancelAutoHideDrawer()"
        >
          <ul class="timeline">
            <li
              v-for="timelayer in getCurrentTimeLayers().reverse()"
              :key="`timelayer_${timelayer.year}`"
              :class="{
                single: getCurrentTimeLayers().length == 1
              }"
              @click="selectTimelayer(timelayer)"
            >
              <div
                :class="{ active: getSelected(timelayer) }"
                :style="{
                  'background-image':
                    'url(' + `${getSelectedColor(timelayer)}` + ')',
                  'background-position': 'left center'
                }"
              >
                <span>
                  {{ timelayer.year }}
                </span>
              </div>
            </li>
          </ul>
        </div>

        <div class="mb-8" @mouseover="cancelAutoHideDrawer()">
          <div
            v-if="this.hasExpertMode == true"
            class="timelayer-drawer-action"
            @click="selectExpertMode()"
          >
            <BaseIcon
              multiplatform
              :icon="expertMode ? 'expertmode-selected' : 'expertmode'"
              size="25px"
              hover
            />
          </div>

          <div class="timelayer-drawer-action" @click="select5DMode()">
            <BaseIcon
              multiplatform
              :icon="select5D ? '5D-selected' : '5D-items'"
              size="25px"
              hover
            />
          </div>
        </div>

        <div
          class="timelayer-toggle-button"
          :class="{
            'timelayer-toggle-button-huygens': getAppName() == 'huygens',
            'timelayer-toggle-button-dordrecht5D':
              getAppName() == 'dordrecht5D',
            'timelayer-toggle-button-canals5D': getAppName() == 'canals5D'
          }"
          @click="() => toggleTimelayerDrawer()"
        >
          <BaseIcon
            class="mr-2"
            icon="arrow-left"
            hover
            :class="!this.drawer ? 'arrow-rotated' : ''"
          />
        </div>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "TimelayerDrawer",
  data: function() {
    return {
      select5D: true,
      expertMode: false,
      drawer: true,
      autoHideDrawerTimerId: null
    };
  },
  computed: {
    ...mapState({
      timeLayer: state => state.timeLayer,
      timeLayers: state => state.timeLayers
    }),
    hasExpertMode() {
      return this.timeLayers.some(layer => {
        return layer.expert;
      });
    },
    timeLayersHeight() {
      let numberOfNormalLayers = this.getNormalTimeLayers().length;
      let numberOfExpertLayers = this.getExpertTimeLayers().length;
      if (numberOfNormalLayers > numberOfExpertLayers) {
        return numberOfNormalLayers * 49;
      } else {
        return numberOfExpertLayers * 49;
      }
    }
  },
  mounted() {
    this.autoHideDrawerTimerId = setTimeout(() => (this.drawer = false), 5000);
  },
  methods: {
    getAppName() {
      return appIdentifier();
    },
    getCurrentTimeLayer() {
      return this.timeLayer;
    },
    getCurrentTimeLayers() {
      if (this.expertMode) {
        return this.getExpertTimeLayers();
      } else {
        return this.getNormalTimeLayers();
      }
    },
    getNormalTimeLayers() {
      return this.timeLayers.filter(layer => !layer.expert);
    },
    getExpertTimeLayers() {
      return this.timeLayers.filter(layer => layer.expert);
    },
    select5DMode() {
      this.select5D = !this.select5D;
      this.$emit("on5DMode", this.select5D);
    },
    selectExpertMode() {
      this.expertMode = !this.expertMode;

      let years = this.getCurrentTimeLayers().map(x => x.year);
      let currentYear = this.getCurrentTimeLayer().year;

      let closestYear = years.reduce(function(prev, curr) {
        return Math.abs(curr - currentYear) < Math.abs(prev - currentYear)
          ? curr
          : prev;
      });

      let newTimeLayer = this.getCurrentTimeLayers().find(
        timeLayer => timeLayer.year == closestYear
      );

      this.selectTimelayer(newTimeLayer);
    },
    selectTimelayer(timelayer) {
      this.$store.commit(this.$mutations.SET_TIMELAYER, timelayer);
      this.$emit("onTimelayerChange", this.timeLayer);
    },
    toggleTimelayerDrawer() {
      this.drawer = !this.drawer;

      if (this.drawer == true) {
        setTimeout(() => (this.drawer = false), 4000);
      }
    },
    getSelected(timelayer) {
      return timelayer.year == this.getCurrentTimeLayer().year;
    },
    getSelectedColor(timelayer) {
      if (timelayer.year == this.getCurrentTimeLayer().year) {
        return `${require(`@/assets/svg/${this.getAppName()}/icon-timeline-selected.svg`)}`;
      }
    },
    cancelAutoHideDrawer() {
      clearTimeout(this.autoHideDrawerTimerId);
    }
  }
};
</script>

<style lang="scss" scoped>
.arrow-rotated {
  transform: rotate(180deg);
}

div#timelayer-drawer {
  z-index: 2;

  div#app {
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;

    div.v-card {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0;
      border: none;

      aside {
        box-shadow: none;
        border: none;

        div.v-navigation-drawer__border {
          display: none;
        }
      }
    }

    .v-navigation-drawer--close .timelayer-toggle-button {
      div {
        transform: rotate(180deg);
      }
    }
  }
}

.timelayers-wrapper {
  display: block;
  width: 100%;
  margin: 20px auto;
}

.v-application ul,
.v-application ol {
  padding-left: 0px;
}

.v-navigation-drawer__content {
  overflow-y: hidden !important;
}

.v-navigation-drawer {
  z-index: 2;
  background-color: var(--v-brand-base) !important;
  opacity: 0.9;

  &--close {
    transform: translateX(-101%) !important;
    visibility: initial !important;
  }
}

.timelayer-drawer-timeline-wrapper-canals5D {
  background-color: var(--v-secondary-base) !important;
}

.timelayer-drawer-timeline-wrapper-huygens {
  background-color: rgba($primary-huygens, 0.9) !important;
}

.timelayer-toggle-button {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 43px;
  top: calc(50% - 40px);
  right: -43px;
  border-top-right-radius: 40px !important;
  border-bottom-right-radius: 40px !important;
  z-index: 5 !important;

  &-huygens {
    background-color: rgba($secondary-huygens, 0.8);
  }

  &-dordrecht5D {
    background-color: rgba($secondary-dordrecht5D, 0.8);
  }

  &-canals5D {
    background-color: rgba($primary-canals5D, 0.8);
  }

  &:hover {
    cursor: pointer;
  }
}

.timelayer-drawer {
  z-index: 10;
  display: flex;
  width: 50px !important;
  align-items: center;
  position: absolute !important;
  top: 33%;
  left: 0;
  right: 0;

  &-action {
    display: flex;
    justify-content: center;
    margin: 30px 0;

    &:hover {
      cursor: pointer;
    }
  }
}

.timelayer-drawer-timeline-wrapper {
  border-top-right-radius: 40px !important;
  border-bottom-right-radius: 40px !important;
  overflow: visible;
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: none;
  border-size: 10px !important;
}

body {
  margin: 0;
  padding: 0;
  background: rgb(230, 230, 230);
  color: rgb(50, 50, 50);
  font-family: "Open Sans", sans-serif;
  font-size: 112.5%;
  line-height: 1.6em;
}

.timeline {
  position: relative;
  width: 410px;
  margin-left: 20px;
  list-style-type: none;

  li {
    height: 49px;
    background-image: url(~@/assets/svg/timeline-middle.svg);
    background-repeat: no-repeat;
    background-position: 2px center;

    vertical-align: middle;
    display: block;
    margin: auto;
    vertical-align: middle;
    padding-left: 0;
    cursor: pointer;

    div {
      color: $white;
      font-family: "AWConquerorCarved-One";
      font-size: 16px;
      letter-spacing: 1.26px;
      height: 49px;
      display: table-cell;
      vertical-align: middle;
      padding-left: 25px;

      span {
        opacity: 0.5;
      }

      &.active {
        span {
          opacity: 1;
        }
      }
    }
  }

  li:first-child {
    background-image: url(~@/assets/svg/timeline-top.svg);
    background-position: 2px bottom;
  }

  li:last-child {
    background-image: url(~@/assets/svg/timeline-bottom.svg);
    background-position: 2px top;
  }

  li.single {
    background-image: none !important;
  }
}

.timelayer-drawer-timeline-wrapper-huygens {
  .timeline {
    li {
      height: 49px;
      background-image: url(~@/assets/svg/huygens/timeline-middle.svg);
    }

    li:first-child {
      background-image: url(~@/assets/svg/huygens/timeline-top.svg);
      background-position: 2px bottom;
    }

    li:last-child {
      background-image: url(~@/assets/svg/huygens/timeline-bottom.svg);
      background-position: 2px top;
    }
  }
}
</style>
